<template>
  <router-view />
</template>

<script lang="js">
/* eslint-disable */

import Vue from 'vue';

export default Vue.extend({
  created() {
    const mapsScript = document.createElement('script');
    mapsScript.type = 'text/javascript';
    mapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&callback=initMap`;
    mapsScript.defer = true;
    window.initMap = () => {
      window.AppSettings.googleLoaded = true;
    };
    document.body.appendChild(mapsScript);

    // when running in development mode, which is vue spa only, 'yarn serve'
    // the site_url shold be set to the development url
    if (process.env.NODE_ENV !== 'production') {
      // const d3Script = document.createElement('script');
      // d3Script.setAttribute('src', 'https://d3js.org/d3.v4.min.js');
      // document.head.appendChild(d3Script);

      window.ga = (...params) => {
        console.log(`[Google Analytics Stub] ${params}`);
      };
    } else {
      (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;

        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));
    }
    ga('create', 'UA-42416674-1', 'onderwijsconsument.nl');
  },
});
</script>

<style lang="scss">
#app {
  margin: 0 auto;
  max-width: 990px;
}
</style>
